import React, { useEffect, useState } from 'react'
import './TravelFinished.min.css'
import { Travel } from '../TravelsPlanned/model'
import axios from "axios";
import { AiFillDelete, AiOutlineArrowDown } from 'react-icons/ai'
import { MdOutlineRemoveDone } from 'react-icons/md'
import Swal from 'sweetalert2'
import BaggagesTravelEnd from './BaggagesTravelEnd'
import CostsTravelEnd from './CostsTravelEnd'
import ShoppingTravelEnd from './ShoppingTravelEnd'
import AttractionsTravelEnd from './AttractionsTravelEnd';
import NotesTravelEnd from './NotesTravelEnd';
import GroupAttractionsTravelEnd from './GroupAttractionsTravelEnd';
import { ipAddress } from '../../ipAddress';

interface Props {
  travelEnd: Travel; // Travel z wielkiej litery zawiera city, date i id.
  travelsEnd: TravelEnd[];
  setTravelsEnd: React.Dispatch<React.SetStateAction<TravelEnd[]>>;
}

interface TravelEnd {
  id: number;
  city: string;
  date: string;
  isDone: number;
}
interface Baggages {
  id: number;
  name: string;
  isDone: number;
}

interface Cost {
  id: number;
  name: string;
  kwota: number;
  isDone: number;
}
interface Shopping {
  id: number;
  name: string;
  isDone: number;
}
interface Attraction {
  id: number;
  name: string;
  isDone: number;
}
interface Note {
  id: number;
  name: string;
  isDone: number;
}

interface AttractionsGroups {
  id: number;
  name: string;
}



const TravelFinished: React.FC<Props> = ({ travelEnd, travelsEnd, setTravelsEnd }) => {
  const [viewCost, setViewCost] = useState<boolean>(false);
  const [viewCostList, setViewCostList] = useState<boolean>(false);
  const [viewShopping, setViewShopping] = useState<boolean>(false);
  const [viewShoppingtList, setViewShoppingList] = useState<boolean>(false);
  const [viewBaggage, setViewBaggage] = useState<boolean>(false);
  const [viewBaggageList, setViewBaggageList] = useState<boolean>(false);
  const [viewAttraction, setViewAttraction] = useState<boolean>(false);
  const [viewAttractionList, setViewAttractionList] = useState<boolean>(false);
  const [viewAttractionGroup, setViewAttractionGroup] = useState<boolean>(false);
  const [viewNote, setViewNote] = useState<boolean>(false);
  const [viewNoteList, setViewNoteList] = useState<boolean>(false);
  const [costsList, setCostsList] = useState<Cost[]>([]);
  const [shoppingList, setShoppingList] = useState<Shopping[]>([]);
  const [baggagesList, setBaggagesList] = useState<Baggages[]>([]);
  const [attractionsList, setAttractionsList] = useState<Attraction[]>([]);
  const [notesList, setNotesList] = useState<Note[]>([]);
  const [resultCost, setResultCost] = useState([]);
  const [costsAll, setCostsAll] = useState<number>(0);
  const [attractionsGroups, setAttractionsGroups] = useState<AttractionsGroups[]>([]);
  const [attractionsListGroup2, setAttractionsListGroup2] = useState<boolean>(false);

  const handleDone = (id: number) => {
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie przeniesiony do zaplanowanych",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, move it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/!doneCity", {
          id: id,
          isDone: 0,
        })
      }
    })
      .then((response) => {
        /*setTravels(travels.map((travel) => travel.id == id ? { ...travel, isDone: 1 } : travel)) */
      })
      .catch(function (error) {
        console.log("error!")

      })
  }


  const handleDelete = (id: number) => {
    Swal.fire({
      title: 'Czy jesteś pewien?',
      text: "Element zostanie na zawsze usunięty!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      heightAuto: false,

    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(ipAddress + "/deletecity", {
          id: id,
        })
        /*setTravels(travels.filter((travel) => (travel.id !== id)))*/
        axios.post(ipAddress + "/deleteTravelCostsAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteThingsToBuyAll", {
          cityId: id,
        })
        axios.post(ipAddress + "/deleteEquipmentAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteAttractionsAll", {

          cityId: id,
        })
        axios.post(ipAddress + "/deleteNotesAll", {

          cityId: id,
        })
      }
    })
  }
  const updateTravelCosts = () => {
    axios.post(ipAddress + "/getTravelCosts", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setCostsList(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })

    setResultCost(costsList.map((cost) => cost.kwota));
    let suma: number = 0;
    for (let i = 0; i < resultCost.length; i++) {
      suma += resultCost[i];

    }
    setCostsAll(suma)

  }
  useEffect(() => {
    updateTravelCosts()
  }, [costsList])


  const updateTravelShopping = () => {
    axios.post(ipAddress + "/getTravelThings", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setShoppingList(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelShopping()
  }, [shoppingList])


  const updateTravelBaggages = () => {
    axios.post(ipAddress + "/getTravelBaggages", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setBaggagesList(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelBaggages()
  }, [baggagesList])

  const updateTravelAttractions = () => {
    axios.post(ipAddress + "/getTravelAttractions", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setAttractionsList(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelAttractions()
  }, [attractionsList])


  const updateTravelAttractionsGroups = () => {
    axios.post(ipAddress + "/getTravelAttractionsGroup", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setAttractionsGroups(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })

  }

  useEffect(() => {
    updateTravelAttractionsGroups()


  }, [attractionsGroups])

  const updateTravelNotes = () => {
    axios.post(ipAddress + "/getTravelNotes", {
      cityId: travelEnd.id,
    })
      .then((response) => {
        setNotesList(response.data)
      }
      )

      .catch(function (error) {
        console.log("error!")
      })
  }

  useEffect(() => {
    updateTravelNotes()
  }, [notesList])


  const visible = () => {
    setViewCost(!viewCost);
    setViewCostList(false);
    setViewShopping(!viewBaggage);
    setViewShoppingList(false);
    setViewBaggage(!viewBaggage);
    setViewBaggageList(false);
    setViewAttraction(!viewAttraction);
    setViewAttractionList(false);
    setViewAttractionGroup(!viewAttractionGroup);
    setAttractionsListGroup2(false);
    setViewNote(!viewNote);
    setViewNoteList(false);
  }



  return (
    <div className='travelFinished'>
      <div className='singleTravel2'>


        {travelEnd.dateEnd.length == 0 ?
          (<span id='text' onClick={() => (visible())}>{travelEnd.city} {travelEnd.date}</span>)
          :
          (<span id='text' onClick={() => (visible())}>{travelEnd.city} {travelEnd.date} : {travelEnd.dateEnd}</span>)}

        {/*<span className='icon' onClick={() => handleDone(travelEnd.id)} ><MdOutlineRemoveDone /></span> */}
        <span className='icon' onClick={() => handleDelete(travelEnd.id)}><AiFillDelete /></span>

      </div>
      <div className='costsList'>

        {
          viewCost ? (
            costsList.length > 0 ? (
              <p><span onClick={() => setViewCostList(!viewCostList)} >Koszt wyjazdu: {costsAll} zł <span className='icon'><AiOutlineArrowDown /></span></span></p>
            ) :
              (
                <p><span>Koszt wyjazdu: {costsAll} zł</span></p>
              )

          ) :
            (<div></div>)
        }
        {
          viewCostList ? (
            costsList.map((cost) => (
              <CostsTravelEnd cost={cost} key={cost.id} />
            ))

          ) : (
            <div></div>
          )
        }
      </div>

      <div className='shoppingList'>
        {
          viewShopping ? (
            shoppingList.length > 0 ? (
              <p><span onClick={() => setViewShoppingList(!viewShoppingtList)} >Zakupy <span className='icon'><AiOutlineArrowDown /></span></span></p>
            ) :
              (
                <p><span>Zakupy</span></p>
              )

          ) :
            (<div></div>)
        }
        {
          viewShoppingtList ? (
            shoppingList.map((thing) => (
              <ShoppingTravelEnd thing={thing} key={thing.id} />
            ))

          ) : (
            <div></div>
          )
        }
      </div>

      <div className='baggagesList'>
        {
          viewBaggage ? (
            baggagesList.length > 0 ? (
              <p><span onClick={() => setViewBaggageList(!viewBaggageList)} >Do spakowania <span className='icon'><AiOutlineArrowDown /></span></span></p>
            ) :
              (
                <p><span>Do spakowania</span></p>
              )

          ) :
            (<div></div>)
        }
        {
          viewBaggageList ? (
            baggagesList.map((baggage) => (
              <BaggagesTravelEnd baggage={baggage} key={baggage.id} />
            ))

          ) : (
            <div></div>
          )
        }
      </div>
      <div className='attractionsList'>

        {
          viewAttractionGroup ? (
            attractionsGroups.length > 0 ? (
              <p><span onClick={() => setAttractionsListGroup2(!attractionsListGroup2)}>Atrakcje <span className='icon'><AiOutlineArrowDown /></span></span></p>
            ) :
              (
                <p><span>Atrakcje</span></p>
              )
            ) :
            (<div></div>)
          }
            {attractionsListGroup2 ? (
            <div>
              {attractionsGroups.map((group) => (
                <GroupAttractionsTravelEnd group={group} key={group.id} travelEnd={travelEnd} />
              ))}
            </div>
          ) : (
            <div></div>
          )
          }

      </div>

   

      <div className='notesList'>
        {
          viewNote ? (
            notesList.length > 0 ? (
              <p><span onClick={() => setViewNoteList(!viewNoteList)} >Notatki <span className='icon'><AiOutlineArrowDown /></span></span></p>
            ) :
              (
                <p><span>Notatki</span></p>
              )

          ) :
            (<div></div>)
        }
        {
          viewNoteList ? (
            notesList.map((note) => (
              <NotesTravelEnd note={note} key={note.id} />
            ))

          ) : (
            <div></div>
          )
        }
      </div>
    </div>
  )
}

export default TravelFinished